import { render, staticRenderFns } from "./FUNItem.vue?vue&type=template&id=23dfd74c"
import script from "./FUNItem.vue?vue&type=script&lang=js"
export * from "./FUNItem.vue?vue&type=script&lang=js"
import style0 from "./FUNItem.vue?vue&type=style&index=0&id=23dfd74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports